// Bilingual dictionary — es (default) and en
export const dict = {
    es: {
        brand: "Vive a lo Grande",
        eyebrow: "FINANZAS PERSONALES",
        hero_title: "El dinero,\nsin complicaciones.",
        hero_desc: "Registra tus ingresos y gastos, entiende tu patrimonio de manera fácil para tomar mejores decisiones financieras y dejar de preocuparte por el dinero, con un asistente que te habla como un amigo, no como un banco.",
        continue_google: "Continuar con Google",
        signing_in: "Iniciando sesión...",
        terms_line: "Lee nuestros",
        terms: "términos",
        and: "y",
        privacy: "privacidad",
        terms_footnote: "AL INICIAR SESIÓN ACEPTAS NUESTROS TÉRMINOS Y PRIVACIDAD.",
        chip_analysis: "Análisis",
        chip_secure: "Seguro",
        chip_ai: "Caesar IA",
        this_month: "ESTE MES",
        net_savings_ok: "Ahorro neto — vas por delante del presupuesto en 4 de 6 categorías.",
        // testimonials
        testimonials_eyebrow: "LO QUE DICEN LOS USUARIOS",
        testimonials_title: "Dinero más claro. Metas más grandes.",
        // Caesar features
        cf_eyebrow: "LO QUE HACE CAESAR POR TI",
        cf_title: "Detén las fugas. Toma el control.",
        cf_leak_title: "Protección automática de fugas y sobregiros",
        cf_leak_desc: "Deja de perder efectivo por suscripciones olvidadas, aumentos de tarifas ocultos y sobregiros accidentales. Caesar escanea tus transacciones 24/7 para detener las fugas antes de que vacíen tu cuenta.",
        cf_debt_title: "Pago de deuda inteligente y optimización del LendScore",
        cf_debt_desc: "Elimina la deuda con altas tasas usando planes personalizados y optimizados por IA. Caesar fortalece tu perfil financiero y tu LendScore para calificar a las mejores tasas en hipotecas, préstamos y tarjetas.",
        cf_dash_title: "Un dashboard, todos los bancos y pasivos",
        cf_dash_desc: "Deja de saltar entre pestañas. Conecta miles de instituciones financieras y ve tu patrimonio real, tu flujo de caja y tu poder de compra en tiempo real.",
        cf_chat_title: "Habla con tu dinero y tu poder de crédito",
        cf_chat_desc: '"¿Puedo pagar un viaje de $400 este finde sin comprometer mis cuentas?" o "¿Estoy listo para una hipoteca?". Pregunta cualquier cosa a Caesar y recibe respuestas al instante con datos reales.',
        // pricing
        pricing_eyebrow: "PRECIOS Y PLANES",
        pricing_title: "Elige tu plan. Domina tu dinero.",
        pricing_sub: "Ya sea que quieras aprender jugando, detener fugas ocultas o desbloquear la gestión completa de tu patrimonio, Caesar tiene un plan que te devuelve cientos de dólares y eleva tu LendScore.",
        pricing_most_popular: "MÁS ELEGIDO",
        tier_explorer_label: "NIVEL 1",
        tier_explorer_name: "Explorer",
        tier_explorer_price: "Gratis",
        tier_explorer_desc: "Comienza con lo esencial y conoce a Caesar.",
        tier_explorer_f1: "Calculadoras financieras: préstamos, ahorros y presupuestos al instante.",
        tier_explorer_f2: "Chat con Caesar: pregúntale lo que sea a tu coach de dinero.",
        tier_explorer_f3: "Juego financiero interactivo: construye hábitos de dinero saludables mientras te diviertes.",
        tier_explorer_cta: "Empezar ahora",
        tier_pro_label: "NIVEL 2",
        tier_pro_name: "Pro Co-Pilot",
        tier_pro_price: "$14.99/mes",
        tier_pro_price_yearly: "$12.49/mes",
        tier_pro_price_yearly_note: "facturado anualmente ($149.99/año)",
        tier_pro_desc: "Todo lo del plan Gratis, más:",
        tier_pro_f0: "Conecta 1 institución (cuentas, ahorros y tarjetas) de forma segura.",
        tier_pro_f1: "Protección automática de fugas y sobregiros.",
        tier_pro_f2: "Optimización de pago de deuda y LendScore con IA.",
        tier_pro_f3: "Alertas de flujo de caja y consejos semanales.",
        tier_pro_cta: "Empezar ahora",
        tier_elite_label: "NIVEL 3",
        tier_elite_name: "Elite Wealth",
        tier_elite_price: "$29.99/mes",
        tier_elite_price_yearly: "$24.99/mes",
        tier_elite_price_yearly_note: "facturado anualmente ($299.99/año)",
        tier_elite_desc: "Todo lo de Pro, más:",
        tier_elite_f0: "Sincronización multi-institución ilimitada.",
        tier_elite_f1: "Rastreador avanzado de inversiones y patrimonio.",
        tier_elite_f2: "Procesamiento IA prioritario y pronósticos profundos de flujo de caja.",
        tier_elite_f3: "Alertas premium de construcción de patrimonio.",
        tier_elite_cta: "Sube al Elite",
        pricing_monthly: "Mensual",
        pricing_yearly: "Anual",
        pricing_yearly_tag: "2 meses gratis",
        pricing_locked_hint: "Desbloquea al subir de plan",
        // arcade
        nav_arcade: "Arcade",
        nav_blog: "Blog",
        arcade_eyebrow: "MONEY ARCADE",
        arcade_title: "Aprende jugando",
        arcade_sub: "Arcade financiero con retos cortos que entrenan tu instinto de dinero. Nuevos niveles se desbloquean pronto.",
        arcade_play: "JUGAR",
        arcade_coming: "PRONTO",
        game_roulette_title: "Ruleta de Suscripciones",
        game_roulette_desc: "Apuntá el arma de billetes. Dispará a las fugas, mantené las útiles. 8 rondas · explicación completa después de cada respuesta.",
        game_splitter_title: "Cash Splitter",
        game_splitter_desc: "Arma de billetes + regla 50/30/20. Disparale a Necesito, Quiero o Ignoro — 8 gastos reales, aprendé dónde va cada dólar.",
        game_crossing_title: "Cash Crossing",
        game_crossing_desc: "Frogger neón cinemático. Una moneda brillante cruza 6 carriles de gastos malos (mora, impulso, 22% APR, sobregiro, lotería, subs) hasta AHORROS.",
        game_compound_title: "Compound Quest",
        game_compound_desc: "Retirado.",
        // compound quest game
        cq_intro_title: "Compound Quest",
        cq_intro_sub: "Interés compuesto · 3 escenarios",
        cq_intro_desc: "Te muestro capital inicial, aporte mensual, tasa y años. Adivinas el valor final. Cerca gana, lejos pierde. Descubre por qué el interés compuesto es la octava maravilla.",
        cq_start: "COMENZAR",
        cq_scenario: "ESCENARIO",
        cq_start_amount: "Capital inicial",
        cq_monthly: "Aporte mensual",
        cq_apr: "Tasa APR",
        cq_years: "Años",
        cq_your_guess: "Tu apuesta",
        cq_lock_in: "APOSTAR",
        cq_too_low: "Muy bajo",
        cq_too_high: "Muy alto",
        cq_hot: "¡CALIENTE!",
        cq_warm: "Tibio",
        cq_cold: "Frío",
        cq_freezing: "Congelado",
        cq_gap: "diferencia",
        cq_tries_left: "Intentos",
        cq_actual: "Valor real",
        cq_next: "SIGUIENTE",
        cq_takeaway_title: "LA OCTAVA MARAVILLA",
        cq_takeaway_body: "El interés compuesto no premia al que gana más, sino al que empieza antes y no toca su dinero.",
        game_debtslayer_title: "Debt Slayer",
        game_debtslayer_desc: "Próximamente: un ninja con katana cortando APRs altas, préstamos abusivos y cada trampa 'compra ahora, pagá después'.",
        game_cashstrike_title: "CA$H STRIKE",
        game_cashstrike_desc: "Una playa, tres cajas y tu súper pistola de agua. Toca la respuesta correcta — la equivocada es fin del juego.",
        game_life_ins_title: "Myth Hunt: Seguros",
        game_life_ins_desc: "Dispara a los mitos. Deja pasar las verdades. Verdad vs mito de seguros de vida, 8 rondas — protección, nunca inversión.",
        // arcade tier gating
        arcade_locked_pro: "Requiere Pro",
        arcade_locked_elite: "Requiere Elite",
        arcade_upgrade_cta: "Sube de plan",
        arcade_demo_switch_tier: "Cambiar plan (demo)",
        arcade_current_tier: "Plan actual",
        // leaderboard
        arcade_beat_pct: "Superaste al {pct}% de jugadores",
        arcade_your_rank: "Tu ranking",
        arcade_top_players: "Top jugadores",
        arcade_no_scores: "Aún no hay puntajes. ¡Sé el primero!",
        // cash splitter game
        cs_intro_title: "Bill Sorter",
        cs_intro_sub: "Regla 50/30/20 · 8 rondas",
        cs_intro_desc: "Cada gasto que aparece debe ir al balde correcto: NECESITO (50%), QUIERO (30%), IGNORO (20% al ahorro). ¡Sé rápido!",
        cs_need: "NECESITO",
        cs_want: "QUIERO",
        cs_skip: "IGNORO",
        cs_start: "COMENZAR",
        cs_results_title: "PUNTAJE",
        cs_correct: "Correctos",
        cs_wrong: "Incorrectos",
        cs_play_again: "JUGAR OTRA",
        cs_50_score: "Adherencia 50/30/20",
        // life insurance game
        li_intro_title: "Myth Hunt",
        li_intro_sub: "Seguros de vida · 3 rondas",
        li_intro_desc: "Regla de oro: el seguro es PROTECCIÓN, no una inversión. Dispara a los mitos, deja pasar las verdades y aprende a proteger a tu familia.",
        li_intro_start: "EMPEZAR",
        li_round: "RONDA",
        li_round1: "MATCH DE PÓLIZAS",
        li_round2: "CAZA DE MITOS",
        li_round3: "CALCULADORA",
        li_round1_help: "Toca la póliza correcta para cada escenario",
        li_round2_help: "Dispara solo a los MITOS. Deja pasar las verdades.",
        li_round3_help: "Ajusta las variables y descubre tu cobertura ideal",
        li_shoot_myth: "¡Mito derribado!",
        li_shot_truth: "¡Ups! Era verdad",
        li_miss: "Se te escapó un mito",
        li_calc_income: "Ingreso anual",
        li_calc_years: "Años a proteger",
        li_calc_existing: "Cobertura existente (grupo)",
        li_calc_debt: "Deudas totales",
        li_calc_result: "Cobertura recomendada",
        li_calc_length: "Duración del término",
        li_calc_premium: "Prima mensual aprox.",
        li_calc_disclaimer: "Estimación educativa, no una cotización.",
        li_takeaway_title: "LO QUE TENÉS QUE RECORDAR",
        li_takeaway_body: "Compra término. Invierte la diferencia. Mantén protección e inversión separadas. Punto.",
        li_next_round: "SIGUIENTE",
        li_finish: "TERMINAR",
        // policy options
        li_policy_term: "Término",
        li_policy_whole: "Vitalicio",
        li_policy_universal: "Universal",
        li_policy_final: "Gastos finales",
        li_policy_key: "Persona clave",
        li_policy_gi: "Emisión garantizada",
        li_policy_redflag: "Alerta roja",
        // category drill-down
        cat_drill_title: "Detalle de {cat}",
        cat_drill_desc: "Transacciones de los últimos 30 días",
        cat_drill_total: "Total",
        cat_drill_count: "Transacciones",
        cat_drill_avg: "Promedio",
        cat_drill_empty: "Sin transacciones en esta categoría.",
        // trust badges
        trust_plaid: "Protegido por Plaid",
        trust_encryption: "Cifrado bancario 256-bit",
        trust_readonly: "Solo lectura",
        // FAQ search
        faq_search_placeholder: "Buscar en preguntas frecuentes...",
        faq_no_results: "No encontramos preguntas que coincidan. Prueba con otras palabras.",
        // how it works
        hiw_eyebrow: "CÓMO FUNCIONA",
        hiw_title: "De cuenta bancaria a plan claro, en 4 pasos.",
        hiw_subtitle: "Sin hojas de cálculo, sin recibos apilados. Conecta, mira, decide, crece — con Caesar acompañándote todo el camino.",
        hiw_step1_title: "Vincula tu banco al instante",
        hiw_step1_desc: "Conecta tus cuentas de forma 100% segura. Tu dinero está totalmente protegido con cifrado bancario: solo leemos la información para darte claridad, nadie toca un solo centavo.",
        hiw_step1_benefit: "Listo en 60 segundos",
        hiw_step2_title: "Descubre en qué se va tu lana",
        hiw_step2_desc: "Olvídate de acomodar gastos a mano. Tu coach de dinero, Caesar, categoriza todo al momento, encuentra fugas invisibles e interpreta tus números por ti.",
        hiw_step2_benefit: "Cero esfuerzo de tu parte",
        hiw_step3_title: "Chatea con Caesar y despeja dudas",
        hiw_step3_desc: "Recibe insights personalizados y pregúntale lo que sea en tiempo real: \"¿Cuánto puedo gastar esta semana?\" o \"¿Cómo voy con mi presupuesto?\". Tu coach te responde al instante.",
        hiw_step3_benefit: "Respuestas al momento",
        hiw_step4_title: "Mejora tu LendScore y atrapa mejores oportunidades",
        hiw_step4_desc: "Usa nuestras calculadoras para entender tus números y monitorea tu LendScore para calificar a mejores préstamos o conseguir esa hipoteca con la que sueñas. ¡Haz crecer tu patrimonio a tu ritmo!",
        hiw_step4_benefit: "Tu dinero trabajando para ti",
        // FAQ
        faq_eyebrow: "PREGUNTAS FRECUENTES",
        faq_title: "Lo que la gente pregunta antes de confiar.",
        faq_q1: "¿Qué tan segura está mi información financiera?",
        faq_a1: "Usamos Plaid — la misma tecnología que usan Venmo, Robinhood y Chime — con cifrado bancario de 256 bits. Nosotros solo leemos tus transacciones para darte claridad; nunca podemos mover, transferir ni retirar tu dinero. Tus contraseñas nunca se guardan.",
        faq_q2: "¿Cuánto cuesta usar Vive a lo Grande?",
        faq_a2: "Comienza gratis con acceso completo al panel, calculadoras y a Caesar. En el futuro habrá un plan premium para funciones avanzadas, pero las herramientas base para tomar control de tu dinero siempre serán gratuitas.",
        faq_q3: "¿Quién es Caesar y cómo me ayuda?",
        faq_a3: "Caesar es tu coach de dinero. Analiza tu flujo real, detecta patrones, sugiere ajustes y responde tus preguntas en español o inglés, cuando quieras. Nunca te juzga — solo te ayuda a decidir mejor.",
        faq_q4: "¿Con qué bancos funciona?",
        faq_a4: "Más de 12,000 instituciones en EE.UU. y Canadá vía Plaid — Chase, Bank of America, Wells Fargo, Capital One, cooperativas, tarjetas de crédito, cuentas de inversión y más. Si tu banco tiene app, muy probablemente funcione.",
        faq_q5: "¿Puedo usar la app en español?",
        faq_a5: "Sí, todo — la interfaz, Caesar, los tips semanales y los reportes — está 100% en español o inglés. Cambia el idioma cuando quieras desde ajustes o el botón en la barra superior.",
        // tour restart (settings)
        settings_tour_title: "Recorrido guiado",
        settings_tour_desc: "Vuelve a ver la introducción de 4 pasos que te mostramos la primera vez.",
        settings_tour_button: "Mostrar recorrido de nuevo",
        // onboarding tour
        tour_next: "Siguiente",
        tour_back: "Atrás",
        tour_skip: "Saltar",
        tour_done: "Empezar",
        tour_step: "Paso",
        tour_of: "de",
        tour_income_title: "Tus ingresos, primero",
        tour_income_desc: "Aquí ves el dinero que entra este mes. Todo se sincroniza automáticamente cuando conectas tu banco.",
        tour_cashflow_title: "Flujo de caja al instante",
        tour_cashflow_desc: "Verde = te sobra al final del mes. Rojo = necesitamos hablar. Caesar te ayuda a mover la aguja.",
        tour_chart_title: "Tu historia, en una línea",
        tour_chart_desc: "El gráfico muestra tu flujo acumulado. Cambia el rango arriba a la derecha para ver más o menos días.",
        tour_caesar_title: "Caesar te acompaña",
        tour_caesar_desc: "Toca el botón brillante abajo a la derecha para preguntarle cualquier cosa: en español o inglés, cuando quieras.",
        tour_plaid_title: "Conecta tu banco para arrancar",
        tour_plaid_desc: "Con Plaid, seguro y sin contraseñas guardadas. Solo lectura — nadie mueve tu dinero por ti.",
        // predictions
        pred_eyebrow: "PRÓXIMOS 30 DÍAS",
        pred_title: "Lo que se viene",
        pred_upcoming: "Próximas facturas",
        pred_forecast: "Balance proyectado",
        pred_no_bills: "No detectamos facturas recurrentes en los próximos 30 días.",
        pred_overdraft_title: "Riesgo de sobregiro",
        pred_overdraft_desc: "Tu balance proyectado podría caer bajo cero antes de tu próximo ingreso. Considera mover fondos o pausar un cargo.",
        pred_safe_title: "Balance saludable",
        pred_safe_desc: "Tu proyección se mantiene positiva durante los próximos 30 días.",
        pred_needs_bank: "Conecta tu banco para ver predicciones basadas en tus movimientos reales.",
        // sidebar
        nav_dashboard: "Panel",
        nav_planning: "Planeación",
        nav_transactions: "Transacciones",
        nav_subscriptions: "Suscripciones",
        nav_goals: "Metas",
        nav_insights: "LendScore",
        nav_notifications: "Notificaciones",
        nav_action_plan: "Plan de acción",
        nav_chat: "Caesar",
        nav_calculator: "Calculadora",
        nav_settings: "Ajustes",
        // dashboard
        greeting: "Hola",
        total_balance: "Saldo total",
        monthly_income: "Ingresos del mes",
        monthly_expenses: "Gastos del mes",
        cash_flow: "Flujo de caja",
        savings_rate: "Tasa de ahorro",
        safe_to_spend: "Seguro para gastar",
        spending_by_category: "Gastos por categoría",
        trend_30d: "Tendencia 30 días",
        connect_bank: "Conectar cuenta bancaria",
        connect_bank_desc: "Conecta tu banco con Caesar para importar transacciones automáticamente.",
        connect: "Conectar",
        connect_demo: "Demo",
        connected: "Conectado",
        sync: "Sincronizar",
        no_data: "Aún no hay datos. Conecta una cuenta para empezar.",
        // transactions
        transactions: "Transacciones",
        all_categories: "Todas las categorías",
        // subscriptions
        subscriptions_total: "Total mensual en suscripciones",
        cancel_recs: "Recomendaciones",
        // goals
        goals: "Metas de ahorro",
        new_goal: "Nueva meta",
        target: "Meta",
        current: "Actual",
        deadline: "Fecha límite",
        save: "Guardar",
        cancel: "Cancelar",
        // insights
        insights: "Análisis",
        health_score: "Puntuación financiera",
        // action plan
        action_plan_title: "Plan de acción mensual",
        generate: "Generar plan",
        // chat
        chat_placeholder: "Pregunta algo, p.ej. ¿En qué gasté más este mes?",
        send: "Enviar",
        // settings
        language: "Idioma",
        theme: "Tema",
        light: "Claro",
        dark: "Oscuro",
        logout: "Cerrar sesión",
        settings_debt_calc: "Calculadora de deudas",
        settings_debt_balance: "Saldo",
        settings_debt_apr: "APR %",
        settings_debt_payment: "Pago mensual",
        settings_debt_calculate: "Calcular",
        settings_debt_months: "Meses",
        settings_debt_payoff_date: "Fecha de pago",
        settings_debt_interest: "Intereses",
        settings_account: "Cuenta",
        // categories
        cat_groceries: "Supermercado",
        cat_dining: "Restaurantes",
        cat_transportation: "Transporte",
        cat_shopping: "Compras",
        cat_utilities: "Servicios",
        cat_healthcare: "Salud",
        cat_medical: "Médico",
        cat_subscriptions: "Suscripciones",
        cat_entertainment: "Entretenimiento",
        cat_income: "Ingresos",
        cat_transfer: "Transferencias",
        cat_housing: "Vivienda",
        cat_rent: "Alquiler",
        cat_mortgage: "Hipoteca",
        cat_home_insurance: "Seguro de hogar",
        cat_property_tax: "Impuesto predial",
        cat_insurance: "Seguros",
        cat_investment: "Inversiones",
        cat_savings: "Ahorros",
        cat_debt_payment: "Pago de deuda",
        cat_loan_repayment: "Pago de préstamo",
        cat_refunded: "Reembolsado",
        cat_cashback: "Cashback",
        cat_salary: "Salario",
        cat_freelance: "Freelance",
        cat_side_income: "Ingreso extra",
        cat_reimbursement: "Reembolso",
        cat_personal_care: "Cuidado personal",
        cat_other: "Otros",
        // dashboard hero rotator variants
        hero_var_a: "¡Hola de nuevo! Ya estamos listos para organizar tus finanzas. Registra tus movimientos, entiende cuánto tienes y toma el control de tu futuro sin estrés. Aquí tu dinero se gestiona con claridad, como si charlaras con un buen amigo.",
        hero_var_b: "Tu patrimonio bajo control y sin rodeos. Registra tus ingresos y gastos hoy mismo para dejar de preocuparte por el dinero. Olvídate de los tecnicismos bancarios; aquí las decisiones financieras se toman fácil y con alguien que realmente te entiende.",
        hero_var_c: "Finanzas claras, vida tranquila. Registra tus gastos e ingresos en un par de clics y entiende el panorama completo de tu dinero. Tu asistente financiero está aquí para ayudarte a decidir mejor, sin complicaciones y con toda la buena vibra.",
        hero_var_d: "Bienvenido a tu espacio para crecer. Registra lo que ganas y lo que gastas para que tu dinero trabaje para ti, no al revés. Deja atrás la ansiedad bancaria y empieza a tomar mejores decisiones financieras, de forma sencilla y clara.",
        // goals tabs
        goal_tab_retirement: "Retiro",
        goal_tab_vacation: "Vacaciones",
        goal_tab_emergency: "Fondo de emergencia",
        goal_tab_debt: "Pago de deuda",
        // goals hero
        goals_hero_eyebrow: "METAS · FINANCIERAS",
        goals_hero_title: "Sueña, planea, alcanza.",
        goals_hero_desc: "Organiza lo que más te importa. Aquí visualizas cómo cada aporte te acerca al retiro, al viaje soñado o a la tranquilidad de un fondo de emergencia.",
        // retirement
        retire_current_age: "Edad actual",
        retire_target_age: "Edad de retiro",
        retire_current_savings: "Ahorros actuales",
        retire_monthly: "Aporte mensual",
        retire_return: "Retorno anual",
        retire_needed_annual: "Gasto anual al jubilarte",
        retire_result: "Capital proyectado",
        retire_gap: "Brecha vs objetivo",
        retire_covered: "Meta alcanzada",
        // vacation
        vac_destination: "Destino soñado",
        vac_cost: "Costo del viaje",
        vac_current: "Ya ahorrado",
        vac_months: "Meses hasta el viaje",
        vac_monthly_needed: "Aporte mensual necesario",
        vac_progress: "Progreso",
        // emergency
        emg_monthly_exp: "Gastos mensuales básicos",
        emg_months: "Meses de cobertura",
        emg_current: "Fondo actual",
        emg_target: "Fondo objetivo",
        emg_status: "Cobertura actual",
        // lendscore widget
        lendscore_title: "LendScore",
        lendscore_sub: "Tu salud financiera",
        lendscore_desc: "Tu LendScore es una foto dinámica de tu salud financiera. Analiza tus hábitos de gasto, tasa de ahorro y consistencia en pagos para mostrarte qué tan 'listo' estás para futuras oportunidades, como préstamos o inversiones grandes.",
        lendscore_view: "Ver detalle",
        lendscore_tier_excellent: "Excelente",
        lendscore_tier_good: "Bien",
        lendscore_tier_fair: "Aceptable",
        lendscore_tier_poor: "En construcción",
        // how it works cards (landing)
        hiw_c1_title: "Conexión segura",
        hiw_c1_desc: "Conecta tus cuentas de forma segura para ver tu panorama financiero en un solo lugar.",
        hiw_c1_cta: "Conectar mi banco",
        hiw_c2_title: "Seguimiento inteligente",
        hiw_c2_desc: "Categorizamos automáticamente tus gastos diarios para que veas exactamente a dónde va tu dinero.",
        hiw_c3_title: "Crecimiento financiero",
        hiw_c3_desc: "Recibe consejos personalizados y alcanza tus metas de ahorro más rápido con tu propio asistente con IA.",
        // landing hero — short punchy 6s auto-crossfade variants (Landing only)
        landing_var_a: "Las cuentas claras y el chocolate espeso.",
        landing_var_b: "Registra tus gastos e ingresos en solo unos clics.",
        landing_var_c: "Mira la imagen completa de tu dinero.",
        landing_var_d: "Tu asistente financiero está aquí para ayudarte: sin complicaciones, solo buenas vibras.",
        // H1 tagline swap — pairs with landing_var_a/b/c/d
        // Template: "El dinero, hecho {adjective}" (no trailing period)
        hero_adj_a: "sin complicaciones",
        hero_adj_b: "fácil de entender",
        hero_adj_c: "sin estrés",
        hero_adj_d: "bajo tu control",
        hero_prefix: "El dinero, hecho",
        hero_suffix: "",
    },
    en: {
        brand: "Vive a lo Grande",
        eyebrow: "PERSONAL FINANCE",
        hero_title: "Money,\nmade simple.",
        hero_desc: "Track your income, spending, and goals in one place — with an assistant that chats with you like a friend, not a bank.",
        continue_google: "Continue with Google",
        signing_in: "Signing in...",
        terms_line: "Read our",
        terms: "terms",
        and: "and",
        privacy: "privacy",
        terms_footnote: "BY SIGNING IN YOU AGREE TO OUR TERMS AND PRIVACY.",
        chip_analysis: "Analysis",
        chip_secure: "Secure",
        chip_ai: "Meet Caesar",
        this_month: "THIS MONTH",
        net_savings_ok: "Net savings — you're ahead of budget in 4 of 6 categories.",
        // testimonials
        testimonials_eyebrow: "WHAT PEOPLE ARE SAYING",
        testimonials_title: "Sharper money. Bigger wins.",
        // Caesar features
        cf_eyebrow: "WHAT CAESAR DOES FOR YOU",
        cf_title: "Stop the leaks. Own your money.",
        cf_leak_title: "Automatic leak & overdraft protection",
        cf_leak_desc: "Stop bleeding cash to forgotten subscriptions, sneaky fee hikes and accidental overdrafts. Caesar scans your transactions 24/7 to stop money leaks before they drain your account.",
        cf_debt_title: "Smart debt payoff & LendScore optimization",
        cf_debt_desc: "Eliminate high-interest debt with custom, optimized payoff paths. Caesar continuously strengthens your profile so you qualify for the lowest rates on mortgages, loans and cards.",
        cf_dash_title: "One dashboard, every bank & liability",
        cf_dash_desc: "Stop jumping between tabs. Connect thousands of institutions and see your real net worth, cash flow and borrowing power in real time.",
        cf_chat_title: "Talk to your money & borrowing power",
        cf_chat_desc: '"Can I afford a $400 weekend trip without risking my bills?" or "Am I ready for a mortgage?" Ask Caesar anything and get instant, data-backed answers.',
        // pricing
        pricing_eyebrow: "PRICING & TIERS",
        pricing_title: "Choose your plan. Master your money.",
        pricing_sub: "Whether you want to learn the ropes with our interactive money game, stop hidden leaks or unlock full multi-institution wealth management, Caesar has a tier built to put hundreds back in your pocket.",
        pricing_most_popular: "MOST POPULAR",
        tier_explorer_label: "TIER 1",
        tier_explorer_name: "Explorer",
        tier_explorer_price: "Free",
        tier_explorer_desc: "Get started with the essentials and meet Caesar.",
        tier_explorer_f1: "Financial calculators: crunch loans, savings and budgets instantly.",
        tier_explorer_f2: "Chat with Caesar: ask your money coach anything.",
        tier_explorer_f3: "Interactive money game: build smart habits while having fun.",
        tier_explorer_cta: "Start now",
        tier_pro_label: "TIER 2",
        tier_pro_name: "Pro Co-Pilot",
        tier_pro_price: "$14.99/mo",
        tier_pro_price_yearly: "$12.49/mo",
        tier_pro_price_yearly_note: "billed annually ($149.99/yr)",
        tier_pro_desc: "Everything in Free, plus:",
        tier_pro_f0: "Securely connect 1 institution (checking, savings & cards).",
        tier_pro_f1: "Automatic leak & overdraft protection.",
        tier_pro_f2: "Guided debt payoff & LendScore optimization.",
        tier_pro_f3: "Cash-flow alerts and weekly actionable tips.",
        tier_pro_cta: "Start now",
        tier_elite_label: "TIER 3",
        tier_elite_name: "Elite Wealth",
        tier_elite_price: "$29.99/mo",
        tier_elite_price_yearly: "$24.99/mo",
        tier_elite_price_yearly_note: "billed annually ($299.99/yr)",
        tier_elite_desc: "Everything in Pro, plus:",
        tier_elite_f0: "Unlimited multi-institution sync across thousands of platforms.",
        tier_elite_f1: "Advanced investment & net-worth tracker.",
        tier_elite_f2: "Priority processing & deep cash-flow forecasting.",
        tier_elite_f3: "Premium wealth-building alerts.",
        tier_elite_cta: "Go Elite",
        pricing_monthly: "Monthly",
        pricing_yearly: "Yearly",
        pricing_yearly_tag: "2 months free",
        pricing_locked_hint: "Unlock by upgrading",
        // arcade
        nav_arcade: "Arcade",
        nav_blog: "Blog",
        arcade_eyebrow: "MONEY ARCADE",
        arcade_title: "Learn by playing",
        arcade_sub: "Short financial mini-games that train your money instincts. New levels unlocking soon.",
        arcade_play: "PLAY",
        arcade_coming: "SOON",
        game_roulette_title: "Subscription Roulette",
        game_roulette_desc: "Aim the money gun. Shoot the leaks, keep the useful. 8 rounds · full explanation after every answer.",
        game_splitter_title: "Cash Splitter",
        game_splitter_desc: "Money gun meets the 50/30/20 rule. Fire at Need, Want or Skip — 8 real expenses, learn where every dollar belongs.",
        game_crossing_title: "Cash Crossing",
        game_crossing_desc: "Cinematic neon Frogger. A glowing coin crosses 6 lanes of bad expenses (late fee, impulse, 22% APR, overdraft, lottery, subs) to reach SAVINGS.",
        game_compound_title: "Compound Quest",
        game_compound_desc: "Retired.",
        // compound quest game
        cq_intro_title: "Compound Quest",
        cq_intro_sub: "Compound interest · 3 scenarios",
        cq_intro_desc: "I show you the starting amount, monthly deposit, APR and years. You guess the final value. Get close to win. Discover why compound interest is the eighth wonder.",
        cq_start: "START",
        cq_scenario: "SCENARIO",
        cq_start_amount: "Starting amount",
        cq_monthly: "Monthly deposit",
        cq_apr: "APR rate",
        cq_years: "Years",
        cq_your_guess: "Your guess",
        cq_lock_in: "LOCK IN",
        cq_too_low: "Too low",
        cq_too_high: "Too high",
        cq_hot: "HOT!",
        cq_warm: "Warm",
        cq_cold: "Cold",
        cq_freezing: "Freezing",
        cq_gap: "gap",
        cq_tries_left: "Tries",
        cq_actual: "Actual value",
        cq_next: "NEXT",
        cq_takeaway_title: "THE EIGHTH WONDER",
        cq_takeaway_body: "Compound interest doesn't reward who earns the most — it rewards who starts earliest and never touches the money.",
        game_debtslayer_title: "Debt Slayer",
        game_debtslayer_desc: "Coming next: a katana-wielding ninja slicing high APRs, predatory loans and every 'buy now, pay later' trap.",
        game_cashstrike_title: "CA$H STRIKE",
        game_cashstrike_desc: "A beach, three crates, and your super soaker. Tap the right answer — the wrong one is game over.",
        game_life_ins_title: "Myth Hunt: Insurance",
        game_life_ins_desc: "Shoot the myths. Let the truths fly. Life-insurance truth vs myth, 8 rounds — protection, never investment.",
        // arcade tier gating
        arcade_locked_pro: "Requires Pro",
        arcade_locked_elite: "Requires Elite",
        arcade_upgrade_cta: "Upgrade tier",
        arcade_demo_switch_tier: "Switch tier (demo)",
        arcade_current_tier: "Current tier",
        // leaderboard
        arcade_beat_pct: "You beat {pct}% of players",
        arcade_your_rank: "Your rank",
        arcade_top_players: "Top players",
        arcade_no_scores: "No scores yet. Be the first!",
        // cash splitter game
        cs_intro_title: "Bill Sorter",
        cs_intro_sub: "50/30/20 rule · 8 rounds",
        cs_intro_desc: "Each expense must land in the correct bucket: NEED (50%), WANT (30%), SKIP (20% to savings). Speed matters!",
        cs_need: "NEED",
        cs_want: "WANT",
        cs_skip: "SKIP",
        cs_start: "START",
        cs_results_title: "SCORE",
        cs_correct: "Correct",
        cs_wrong: "Wrong",
        cs_play_again: "PLAY AGAIN",
        cs_50_score: "50/30/20 adherence",
        // life insurance game
        li_intro_title: "Myth Hunt",
        li_intro_sub: "Life insurance · 3 rounds",
        li_intro_desc: "Golden rule: insurance is PROTECTION, not an investment. Shoot the myths, let truths fly by, and learn how to protect your family.",
        li_intro_start: "START",
        li_round: "ROUND",
        li_round1: "POLICY MATCH",
        li_round2: "MYTH HUNT",
        li_round3: "CALCULATOR",
        li_round1_help: "Tap the right policy for each scenario",
        li_round2_help: "Shoot MYTHS only. Let truths fly by.",
        li_round3_help: "Adjust the sliders and see your ideal coverage",
        li_shoot_myth: "Myth busted!",
        li_shot_truth: "Oops! That was true",
        li_miss: "A myth got away",
        li_calc_income: "Annual income",
        li_calc_years: "Years to protect",
        li_calc_existing: "Existing group coverage",
        li_calc_debt: "Total debt",
        li_calc_result: "Recommended coverage",
        li_calc_length: "Term length",
        li_calc_premium: "Rough monthly premium",
        li_calc_disclaimer: "Educational estimate, not a quote.",
        li_takeaway_title: "THE ONE THING TO REMEMBER",
        li_takeaway_body: "Buy term. Invest the difference. Keep protection and investment separate. That's it.",
        li_next_round: "NEXT",
        li_finish: "FINISH",
        // policy options
        li_policy_term: "Term",
        li_policy_whole: "Whole",
        li_policy_universal: "Universal",
        li_policy_final: "Final expense",
        li_policy_key: "Key-person",
        li_policy_gi: "Guaranteed-issue",
        li_policy_redflag: "Red flag",
        // category drill-down
        cat_drill_title: "{cat} details",
        cat_drill_desc: "Last 30 days of transactions",
        cat_drill_total: "Total",
        cat_drill_count: "Transactions",
        cat_drill_avg: "Average",
        cat_drill_empty: "No transactions in this category.",
        // trust badges
        trust_plaid: "Secured by Plaid",
        trust_encryption: "256-bit bank-grade encryption",
        trust_readonly: "Read-only access",
        // FAQ search
        faq_search_placeholder: "Search frequently asked...",
        faq_no_results: "No questions match — try different words.",
        // how it works
        hiw_eyebrow: "HOW IT WORKS",
        hiw_title: "From bank account to clear plan, in 4 steps.",
        hiw_subtitle: "No spreadsheets, no stacks of receipts. Connect, see, decide, grow — with Caesar walking with you the whole way.",
        hiw_step1_title: "Link your bank in seconds",
        hiw_step1_desc: "Connect your accounts 100% securely. Your money is fully protected with bank-grade encryption — we only read your data to give you clarity, nobody touches a single cent.",
        hiw_step1_benefit: "Ready in 60 seconds",
        hiw_step2_title: "See where your money goes",
        hiw_step2_desc: "Forget sorting expenses by hand. Your money coach, Caesar, categorizes everything instantly, spots invisible leaks and interprets your numbers for you.",
        hiw_step2_benefit: "Zero effort from you",
        hiw_step3_title: "Chat with Caesar, clear every doubt",
        hiw_step3_desc: "Get personalized insights and ask anything in real time: \"How much can I spend this week?\" or \"How am I doing on my budget?\" — your coach answers instantly.",
        hiw_step3_benefit: "Instant answers",
        hiw_step4_title: "Level up your LendScore, unlock better opportunities",
        hiw_step4_desc: "Use our calculators to understand your numbers and monitor your LendScore to qualify for better loans or land that dream mortgage. Grow your wealth at your own pace!",
        hiw_step4_benefit: "Your money working for you",
        // FAQ
        faq_eyebrow: "FREQUENTLY ASKED",
        faq_title: "What people ask before they trust us.",
        faq_q1: "How safe is my financial information?",
        faq_a1: "We use Plaid — the same technology behind Venmo, Robinhood and Chime — with 256-bit bank-grade encryption. We only read your transactions to give you clarity; we can never move, transfer, or withdraw your money. Your passwords are never stored.",
        faq_q2: "How much does Vive a lo Grande cost?",
        faq_a2: "Start free with full access to the dashboard, calculators and Caesar. A premium tier is coming for advanced features, but the core tools to take control of your money will always be free.",
        faq_q3: "Who is Caesar and how does he help me?",
        faq_a3: "Caesar is your money coach. He analyzes your real cash flow, spots patterns, suggests adjustments and answers your questions in English or Spanish, anytime. Never judges — just helps you decide better.",
        faq_q4: "Which banks does it work with?",
        faq_a4: "Over 12,000 institutions across the US and Canada via Plaid — Chase, Bank of America, Wells Fargo, Capital One, credit unions, credit cards, brokerage accounts and more. If your bank has an app, it very likely works.",
        faq_q5: "Can I use the app in Spanish?",
        faq_a5: "Yes — everything: the interface, Caesar, weekly tips and reports — is 100% in English or Spanish. Switch anytime from Settings or the toggle in the top bar.",
        // tour restart (settings)
        settings_tour_title: "Guided tour",
        settings_tour_desc: "Replay the 4-step intro we showed you the first time.",
        settings_tour_button: "Show tour again",
        // onboarding tour
        tour_next: "Next",
        tour_back: "Back",
        tour_skip: "Skip",
        tour_done: "Let's go",
        tour_step: "Step",
        tour_of: "of",
        tour_income_title: "Your income, front and center",
        tour_income_desc: "This is money coming in this month. It syncs automatically once you connect a bank.",
        tour_cashflow_title: "Cash flow, at a glance",
        tour_cashflow_desc: "Green = you'll finish the month ahead. Red = we need to talk. Caesar can help move the needle.",
        tour_chart_title: "Your story, one line",
        tour_chart_desc: "The chart tracks cumulative cash flow. Use the range chips top-right to zoom out or in.",
        tour_caesar_title: "Caesar has your back",
        tour_caesar_desc: "Tap the glowing button bottom-right to ask anything — English or Spanish, whenever you want.",
        tour_plaid_title: "Connect a bank to kick things off",
        tour_plaid_desc: "Powered by Plaid — secure, no stored passwords, read-only. Nobody moves money for you.",
        // predictions
        pred_eyebrow: "NEXT 30 DAYS",
        pred_title: "What's coming up",
        pred_upcoming: "Upcoming bills",
        pred_forecast: "Balance forecast",
        pred_no_bills: "No recurring bills detected in the next 30 days.",
        pred_overdraft_title: "Overdraft risk ahead",
        pred_overdraft_desc: "Your projected balance may dip below zero before your next paycheck. Consider moving funds or pausing a charge.",
        pred_safe_title: "Balance looking healthy",
        pred_safe_desc: "Your projection stays positive across the next 30 days.",
        pred_needs_bank: "Connect your bank to see predictions from your real activity.",
        nav_dashboard: "Dashboard",
        nav_planning: "Planning",
        nav_transactions: "Transactions",
        nav_subscriptions: "Subscriptions",
        nav_goals: "Goals",
        nav_insights: "LendScore",
        nav_notifications: "Notifications",
        nav_action_plan: "Action plan",
        nav_chat: "Caesar",
        nav_calculator: "Calculator",
        nav_settings: "Settings",
        greeting: "Hello",
        total_balance: "Total balance",
        monthly_income: "Monthly income",
        monthly_expenses: "Monthly expenses",
        cash_flow: "Cash flow",
        savings_rate: "Savings rate",
        safe_to_spend: "Safe to spend",
        spending_by_category: "Spending by category",
        trend_30d: "30-day trend",
        connect_bank: "Connect a bank account",
        connect_bank_desc: "Link your bank with Caesar to import transactions automatically.",
        connect: "Connect",
        connect_demo: "Demo",
        connected: "Connected",
        sync: "Sync",
        no_data: "No data yet. Connect an account to get started.",
        transactions: "Transactions",
        all_categories: "All categories",
        subscriptions_total: "Monthly subscription total",
        cancel_recs: "Recommendations",
        goals: "Savings goals",
        new_goal: "New goal",
        target: "Target",
        current: "Current",
        deadline: "Deadline",
        save: "Save",
        cancel: "Cancel",
        insights: "Insights",
        health_score: "Financial health score",
        action_plan_title: "Monthly action plan",
        generate: "Generate plan",
        chat_placeholder: "Ask anything, e.g. Where did I spend the most this month?",
        send: "Send",
        language: "Language",
        theme: "Theme",
        light: "Light",
        dark: "Dark",
        logout: "Log out",
        settings_debt_calc: "Debt payoff calculator",
        settings_debt_balance: "Balance",
        settings_debt_apr: "APR %",
        settings_debt_payment: "Monthly payment",
        settings_debt_calculate: "Calculate",
        settings_debt_months: "Months",
        settings_debt_payoff_date: "Payoff date",
        settings_debt_interest: "Interest",
        settings_account: "Account",
        cat_groceries: "Groceries",
        cat_dining: "Dining",
        cat_transportation: "Transportation",
        cat_shopping: "Shopping",
        cat_utilities: "Utilities",
        cat_healthcare: "Healthcare",
        cat_medical: "Medical",
        cat_subscriptions: "Subscriptions",
        cat_entertainment: "Entertainment",
        cat_income: "Income",
        cat_transfer: "Transfer",
        cat_housing: "Housing",
        cat_rent: "Rent",
        cat_mortgage: "Mortgage",
        cat_home_insurance: "Home insurance",
        cat_property_tax: "Property tax",
        cat_insurance: "Insurance",
        cat_investment: "Investment",
        cat_savings: "Savings",
        cat_debt_payment: "Debt payment",
        cat_loan_repayment: "Loan repayment",
        cat_refunded: "Refunded",
        cat_cashback: "Cashback",
        cat_salary: "Salary",
        cat_freelance: "Freelance",
        cat_side_income: "Side income",
        cat_reimbursement: "Reimbursement",
        cat_personal_care: "Personal care",
        cat_other: "Other",
        // dashboard hero rotator variants
        hero_var_a: "Welcome back! We're ready to organize your finances. Log your transactions, understand your net worth, and take control of your future without the stress. Here, your money is managed with clarity, just like chatting with a good friend.",
        hero_var_b: "Your net worth under control, no strings attached. Log your income and expenses today so you can stop worrying about money. Forget banking jargon; here, financial decisions are made easily and with someone who truly understands you.",
        hero_var_c: "Clear finances, peaceful life. Log your expenses and income in a couple of clicks and see the big picture of your money. Your financial assistant is here to help you make better decisions—no complications, just good vibes.",
        hero_var_d: "Welcome to your space to grow. Log what you earn and what you spend so your money works for you, not the other way around. Leave the banking anxiety behind and start making better financial decisions, simply and clearly.",
        // goals tabs
        goal_tab_retirement: "Retirement",
        goal_tab_vacation: "Vacation",
        goal_tab_emergency: "Emergency fund",
        goal_tab_debt: "Debt payoff",
        // goals hero
        goals_hero_eyebrow: "FINANCIAL · GOALS",
        goals_hero_title: "Dream, plan, achieve.",
        goals_hero_desc: "Organize what matters most. See how every contribution moves you closer to retirement, the trip of a lifetime, or the peace of mind of an emergency fund.",
        // retirement
        retire_current_age: "Current age",
        retire_target_age: "Retirement age",
        retire_current_savings: "Current savings",
        retire_monthly: "Monthly contribution",
        retire_return: "Annual return",
        retire_needed_annual: "Annual spend at retirement",
        retire_result: "Projected nest egg",
        retire_gap: "Gap vs target",
        retire_covered: "Target reached",
        // vacation
        vac_destination: "Dream destination",
        vac_cost: "Trip cost",
        vac_current: "Saved so far",
        vac_months: "Months until trip",
        vac_monthly_needed: "Monthly amount needed",
        vac_progress: "Progress",
        // emergency
        emg_monthly_exp: "Basic monthly expenses",
        emg_months: "Months of coverage",
        emg_current: "Current fund",
        emg_target: "Target fund",
        emg_status: "Current coverage",
        // lendscore widget
        lendscore_title: "LendScore",
        lendscore_sub: "Your financial health",
        lendscore_desc: "Your LendScore is a dynamic snapshot of your financial health. It analyzes your spending habits, savings rate, and bill consistency to show you how 'ready' you are for future opportunities, like loans or major investments.",
        lendscore_view: "See breakdown",
        lendscore_tier_excellent: "Excellent",
        lendscore_tier_good: "Good",
        lendscore_tier_fair: "Fair",
        lendscore_tier_poor: "Building",
        // how it works cards (landing)
        hiw_c1_title: "Secure Connection",
        hiw_c1_desc: "Connect your accounts securely to see your financial picture in one place.",
        hiw_c1_cta: "Connect My Bank",
        hiw_c2_title: "Smart Tracking",
        hiw_c2_desc: "Automatically categorize your daily spending to see exactly where your money goes.",
        hiw_c3_title: "Financial Growth",
        hiw_c3_desc: "Get personalized advice and reach your savings goals faster with your own money coach.",
        // landing hero — short punchy 6s auto-crossfade variants (Landing only)
        landing_var_a: "Clear numbers. Total peace of mind.",
        landing_var_b: "Log expenses and income in just a few clicks.",
        landing_var_c: "See the big picture of your money.",
        landing_var_d: "Your financial assistant is here to help: no complications, just good vibes.",
        // H1 tagline swap — pairs with landing_var_a/b/c/d
        // Template: "Money, made {adjective}" (no trailing period)
        hero_adj_a: "simple",
        hero_adj_b: "clear",
        hero_adj_c: "calm",
        hero_adj_d: "yours",
        hero_prefix: "Money, made",
        hero_suffix: "",
    },
};

export const t = (lang, key) => {
    const v = dict[lang] && dict[lang][key];
    if (v !== undefined) return v;
    const fb = dict.es[key];
    return fb !== undefined ? fb : key;
};
